export enum KycDocumentErrorCodes {
  // website
  WebsiteUnderConstruction = 'website_under_construction',
  WebsiteNotAvailable = 'website_not_available',
  WebsiteDeactivated = 'website_deactivated',
  WebsiteTemplate = 'website_template',
  WebsiteMissingPrices = 'website_missing_prices',
  WebsiteProductsMismatch = 'website_products_mismatch',
  CounterfeitProducts = 'counterfeit_products',
  WebsiteIndustryMismatch = 'website_industry_mismatch',
  // documents
  DocumentsMissmatch = 'documents_missmatch',
  DocumentsMissing = 'documents_missing',
  DocumentsMissingFields = 'documents_missing_fields',
  DocumentsInvalid = 'documents_invalid',
  DocumentsWrongFormat = 'documents_wrong_format',
  DocumentsCorrupt = 'documents_corrupt',
  DocumentsDuplicateType = 'documents_duplicate_type',
  DocumentsExpired = 'documents_expired',
  DocumentsExpiredId = 'documents_expired_id',
  DocumentsExpiredStatute = 'documents_expired_statute',
  DocumentsFailedOther = 'documents_failed_other',
  DocumentsTypeNotSupported = 'documents_type_not_supported',
  DocumentsBadText = 'documents_bad_text',
  DocumentsBlurryText = 'documents_blurry_text',
  DocumentsSmallImageSize = 'documents_small_image_size',
  DocumentsUnexpectedData = 'documents_unexpected_data',
  DocumentsNoText = 'documents_no_text',
  DocumentsNoFace = 'documents_no_face',
  DocumentsGrayscaleImage = 'documents_grayscale_image',
  DocumentsScreenPhoto = 'documents_screen_photo',
  DocumentsIncomplete = 'documents_incomplete',
  DocumentNotReadable = 'document_not_readable',
  DocumentsCropped = 'documents_cropped',
  DocumentsPhotoMismatch = 'documents_photo_mismatch',
  // validation
  ValidationFailedOther = 'validation_failed_other',
  ValidationMissingShareholder = 'validation_missing_shareholder',
  ValidationMissingDirector = 'validation_missing_director',
  ValidationMissingUbo = 'validation_missing_ubo',
  ValidationProhibitedIndustries = 'validation_prohibited_industries',
  ValidationLegalIssues = 'validation_legal_issues',
  // tax id
  TaxIdInvalid = 'tax_id_invalid',
  TaxIdInactive = 'tax_id_inactive',
  TaxIdExpired = 'tax_id_expired',
  TaxIdOther = 'tax_id_other',
  // industry
  FinancialBusiness = 'financial_business',
  CarTruckServices = 'car_truck_services',
  AnimalProductsServices = 'animal_products_services',
  RealEstateServices = 'real_estate_services',
  RelationshipServices = 'relationship_services',
  NonProfit = 'non_profit',
  Gambling = 'gambling',
  MarketingPractices = 'marketing_practices',
  IllegalProductsServices = 'illegal_products_services',
  MedicalProductsServices = 'medical_products_services',
  ArtAndJewellery = 'art_and_jewellery',
  HazardousMaterials = 'hazardous_materials',
  TechnologyServices = 'technology_services',
  TurismServices = 'turism_services',
  SecuritiesAndTradingServices = 'securities_and_trading_services',
  TicketAgencies = 'ticket_agencies',
  AdultGoods = 'adult_goods',
  ThirdPartyPaymentProcessing = 'third_party_payment_processing',
  ExtractiveIndustry = 'extractive_industry',
  DropShipping = 'drop_shipping',
  GovernmentalServices = 'governmental_services',
  PoliticalReligiousSocialCampaigning = 'political_religious_social_campaigning',
  // others
  Rejected = 'rejected',
  SelfieNotValid = 'selfie_not_valid',
  SelfieNoFace = 'selfie_no_face',
  SelfieMultipleFaces = 'selfie_multiple_faces',
  Underage = 'underage',
  LegalRepresentativeNotFoundInCompany = 'legal_representative_not_found_in_company',
  // fallback
  Unknown = 'unknown',
}
